export function getMimeType(name: string): string {
    return name.substr(name.lastIndexOf(".") + 1, name.length).toLowerCase();
}
